"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _state = require("printableWorksheets/state");
var _react = _interopRequireWildcard(require("react"));
require("./styles.scss");
var _treeViewArrow = _interopRequireDefault(require("./treeViewArrow.svg"));
var _teacherTreeViewArrow = _interopRequireDefault(require("./teacherTreeViewArrow.svg"));
var _rightArrow = _interopRequireDefault(require("./right-arrow.svg"));
var _Button = _interopRequireWildcard(require("printableWorksheets/atoms/Button"));
var _printableWorksheets = require("printableWorksheets");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WorksheetTopicSelector = function WorksheetTopicSelector() {
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    isMobile = _useAppMediaProvider.isMobile;
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    _usePrintableWorkshee2 = _usePrintableWorkshee.treeData,
    treeData = _usePrintableWorkshee2 === void 0 ? {} : _usePrintableWorkshee2,
    setActiveBreadcrumb = _usePrintableWorkshee.setActiveBreadcrumb,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    subjectCode = _usePrintableWorkshee.subjectCode,
    setShowHeader = _usePrintableWorkshee.setShowHeader,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    activeGrade = _usePrintableWorkshee.activeGrade;
  var _useState = (0, _react.useState)(activeBreadcrumb.length > 0 ? activeBreadcrumb.map(function (crumb) {
      return crumb === null || crumb === void 0 ? void 0 : crumb.id;
    }) : []),
    _useState2 = _slicedToArray(_useState, 2),
    visibleNodes = _useState2[0],
    setVisibleNodes = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    regenerateCrumbs = _useState4[0],
    setRegenerateCrumbs = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    mobileList2 = _useState6[0],
    setMobileList2 = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    mobileList3 = _useState8[0],
    setMobileList3 = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    lastNode = _useState10[0],
    setLastNode = _useState10[1];
  var _useState11 = (0, _react.useState)(["math", "ela"]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedSubjects = _useState12[0],
    setSelectedSubjects = _useState12[1];
  (0, _react.useEffect)(function () {
    setVisibleNodes(activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.map(function (crumb) {
      return crumb === null || crumb === void 0 ? void 0 : crumb.id;
    }));
  }, [activeBreadcrumb]);
  (0, _react.useEffect)(function () {
    if (regenerateCrumbs) {
      setRegenerateCrumbs(false);
      getCrumbsFromNodeList();
    }
  }, [regenerateCrumbs]);
  var getParentNode = function getParentNode(nodeId, itemType) {
    var nodeToReturn;
    visibleNodes.find(function (node) {
      var _crumb$children;
      var crumb = findItemById(node, treeData[itemType]);
      var parent = crumb === null || crumb === void 0 ? void 0 : (_crumb$children = crumb.children) === null || _crumb$children === void 0 ? void 0 : _crumb$children.find(function (child) {
        return child.id === nodeId;
      });
      if (parent) {
        nodeToReturn = crumb;
      }
    });
    return nodeToReturn;
  };
  var getCrumbsFromNodeList = function getCrumbsFromNodeList() {
    var crumbs = [];
    visibleNodes.forEach(function (item) {
      var element = findItemById(item, treeData[0]);
      if (element) {
        crumbs.push(element);
      } else {
        var _element = findItemById(item, treeData[1]);
        crumbs.push(_element);
      }
    });
    setActiveBreadcrumb(crumbs);
  };
  var findItemById = function findItemById(id, data) {
    // Check if the current level contains the desired ID
    if (data.id === id) {
      return data; // Return the item if the ID matches
    }

    // Check if the current level has children
    if (data.children && data.children.length > 0) {
      // Iterate through the children and recursively search for the ID
      for (var i = 0; i < data.children.length; i++) {
        var foundItem = findItemById(id, data.children[i]);
        if (foundItem) {
          return foundItem; // Return the found item
        }
      }
    }

    // Item not found
    return null;
  };
  var topicClicked = function topicClicked(lastNode) {
    var itemType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    arrowClicked(lastNode, itemType);
    setRegenerateCrumbs(true);
  };
  var arrowClicked = function arrowClicked(lastNode) {
    var _activeBreadcrumb$, _treeData$itemType;
    var itemType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var props = {
      clickedOn: 'Topic Selector',
      grade: onboardingGrade,
      newTopicSelected: lastNode === null || lastNode === void 0 ? void 0 : lastNode.title,
      newGradeSelected: ''
    };
    _events["default"].interactedPrintablesFilters(props);
    var subOfFirstBreadcrumb = getSubjectCodeOfFirstBreadcrumb();
    if (itemType != null && (itemType != subOfFirstBreadcrumb || (visibleNodes === null || visibleNodes === void 0 ? void 0 : visibleNodes[0]) !== (activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.id)) && (treeData === null || treeData === void 0 ? void 0 : (_treeData$itemType = treeData[itemType]) === null || _treeData$itemType === void 0 ? void 0 : _treeData$itemType.id) !== visibleNodes[0]) {
      visibleNodes[0] = treeData === null || treeData === void 0 ? void 0 : treeData[itemType].id;
      visibleNodes.length = 1;
    }
    if (lastNode.id === visibleNodes[visibleNodes.length - 1]) {
      // if user clicks on the same node which he just opened it should close.
      visibleNodes.length = visibleNodes.length - 1;
      setVisibleNodes(_toConsumableArray(visibleNodes));
    } else {
      var parent = getParentNode(lastNode.id, itemType);
      if (parent) {
        if (parent.children.find(function (child) {
          return child.id === lastNode.id;
        })) {
          // if user clicks on another child of same parent which was last opened
          if (parent.children.find(function (child) {
            return child.id === visibleNodes[visibleNodes.length - 1];
          })) {
            visibleNodes.length = visibleNodes.length - 1;
            setVisibleNodes([].concat(_toConsumableArray(visibleNodes), [lastNode.id]));
          } else {
            var index = visibleNodes.findIndex(function (node) {
              return parent.id == node;
            });
            visibleNodes.length = index + 1;
            setVisibleNodes([].concat(_toConsumableArray(visibleNodes), [lastNode.id]));
          }
        } else {
          // if user clicks on one of the child nodes of already opened parent (not the last parent)
          var _index = visibleNodes.findIndex(function (node) {
            return parent.id == node;
          });
          visibleNodes.length = _index + 1;
          setVisibleNodes([].concat(_toConsumableArray(visibleNodes), [lastNode.id]));
        }
      } else {
        setVisibleNodes([].concat(_toConsumableArray(visibleNodes), [lastNode.id]));
      }
    }
  };
  var renderArrow = function renderArrow(isSelected, isActive, item, itemType) {
    if (isSelected) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "opened-caret".concat(isActive ? ' highlighted-caret' : ''),
        onClick: function onClick(e) {
          e.stopPropagation();
          arrowClicked(item, itemType);
        }
      }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement(_teacherTreeViewArrow["default"], null) : /*#__PURE__*/_react["default"].createElement(_treeViewArrow["default"], null));
    } else {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "caret-icon-container",
        onClick: function onClick(e) {
          e.stopPropagation();
          arrowClicked(item, itemType);
        }
      }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement(_teacherTreeViewArrow["default"], null) : /*#__PURE__*/_react["default"].createElement(_treeViewArrow["default"], null));
    }
  };
  var renderTopics = function renderTopics(data, itemType) {
    var _data$children;
    var isRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return data === null || data === void 0 ? void 0 : (_data$children = data.children) === null || _data$children === void 0 ? void 0 : _data$children.map(function (item) {
      var _item$children, _item$children2;
      var isActive = visibleNodes[visibleNodes.length - 1] === item.id;
      var isExpanded = visibleNodes.includes(item.id);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.id,
        className: "worksheet-topic-container".concat(isRoot ? " root-topic-container" : "")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return topicClicked(item, itemType);
        },
        className: "worksheet-topic-name".concat(isActive ? ' selected' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "worksheet-label"
      }, isRoot ? null : isExpanded ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "marker"
      }) : null, item.title), (item === null || item === void 0 ? void 0 : (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0 ? renderArrow(isExpanded, isActive, item, itemType) : null), /*#__PURE__*/_react["default"].createElement("div", {
        className: "worksheet-topic-children"
      }, (item === null || item === void 0 ? void 0 : (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0 && visibleNodes.includes(item.id) ? renderTopics(item, itemType) : null));
    });
  };
  var toggleSelectedSubjects = function toggleSelectedSubjects(sub) {
    if (selectedSubjects.includes(sub)) {
      setSelectedSubjects(selectedSubjects.filter(function (subject) {
        return subject !== sub;
      }));
    } else {
      setSelectedSubjects([].concat(_toConsumableArray(selectedSubjects), [sub]));
    }
  };
  var renderDesktopTopics = function renderDesktopTopics() {
    var isMathSelected = selectedSubjects.includes("math");
    var isElaSelected = selectedSubjects.includes("ela");
    return worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? renderTeacherDashboardTopics(true) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "worksheet-subject-name",
      onClick: function onClick(e) {
        e.stopPropagation();
        setActiveBreadcrumb([treeData === null || treeData === void 0 ? void 0 : treeData[1]]);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "marker"
    }), "MATH", /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(event) {
        event.stopPropagation();
        toggleSelectedSubjects("math");
      },
      className: isMathSelected ? 'opened-caret highlighted-caret' : 'caret-icon-container'
    }, /*#__PURE__*/_react["default"].createElement(_treeViewArrow["default"], null))), selectedSubjects.includes("math") ? renderTopics(treeData === null || treeData === void 0 ? void 0 : treeData[1], 1) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "worksheet-subject-name",
      onClick: function onClick(e) {
        e.stopPropagation();
        setActiveBreadcrumb([treeData === null || treeData === void 0 ? void 0 : treeData[0]]);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "marker"
    }), "ELA", /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(event) {
        event.stopPropagation();
        toggleSelectedSubjects("ela");
      },
      className: isElaSelected ? 'opened-caret highlighted-caret' : 'caret-icon-container'
    }, /*#__PURE__*/_react["default"].createElement(_treeViewArrow["default"], null))), selectedSubjects.includes("ela") ? renderTopics(treeData === null || treeData === void 0 ? void 0 : treeData[0], 0) : null);
  };
  var renderTeacherDashboardTopics = function renderTeacherDashboardTopics() {
    var isRoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var subjectCode = getCurrentSelectedSubjectCode();
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderTopics(treeData === null || treeData === void 0 ? void 0 : treeData[subjectCode], subjectCode, isRoot));
  };
  var getCount = function getCount() {
    if (lastNode) {
      return "(".concat(lastNode.item.playable_count, ")");
    } else if (mobileList3) {
      return "(".concat(mobileList3.item.playable_count, ")");
    } else if (mobileList2) {
      return "(".concat(mobileList2.item.playable_count, ")");
    }
  };
  var shouldShowResetButton = function shouldShowResetButton() {
    if (visibleNodes.length) {
      if (lastNode && lastNode.data.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else if (!lastNode && mobileList3 && mobileList3.data.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else if (!lastNode && !mobileList3 && mobileList2 && mobileList2.data.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  var getCurrentSelectedSubjectCode = function getCurrentSelectedSubjectCode() {
    return subjectCode === "ela" ? 0 : 1;
  };
  var getSubjectCodeOfFirstBreadcrumb = function getSubjectCodeOfFirstBreadcrumb() {
    var _activeBreadcrumb$2;
    return (activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : (_activeBreadcrumb$2 = activeBreadcrumb[0]) === null || _activeBreadcrumb$2 === void 0 ? void 0 : _activeBreadcrumb$2.title) === "Math" ? 1 : 0;
  };
  var renderMobileView = function renderMobileView() {
    var _mobileList2$item, _mobileList2$item$chi, _mobileList3$item, _mobileList3$item$chi;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "levels-container"
    }, renderMobileTopics(treeData === null || treeData === void 0 ? void 0 : treeData[getCurrentSelectedSubjectCode()], getCurrentSelectedSubjectCode(), 0), (mobileList2 === null || mobileList2 === void 0 ? void 0 : (_mobileList2$item = mobileList2.item) === null || _mobileList2$item === void 0 ? void 0 : (_mobileList2$item$chi = _mobileList2$item.children) === null || _mobileList2$item$chi === void 0 ? void 0 : _mobileList2$item$chi.length) > 0 ? renderMobileTopics(mobileList2 === null || mobileList2 === void 0 ? void 0 : mobileList2.item, getCurrentSelectedSubjectCode(), 1) : null, (mobileList3 === null || mobileList3 === void 0 ? void 0 : (_mobileList3$item = mobileList3.item) === null || _mobileList3$item === void 0 ? void 0 : (_mobileList3$item$chi = _mobileList3$item.children) === null || _mobileList3$item$chi === void 0 ? void 0 : _mobileList3$item$chi.length) > 0 ? renderMobileTopics(mobileList3 === null || mobileList3 === void 0 ? void 0 : mobileList3.item, getCurrentSelectedSubjectCode(), 2) : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "levels-cta-container"
    }, shouldShowResetButton() ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: _Button.ButtonTypes.primary,
      onClick: function onClick() {
        setMobileList2(null);
        setMobileList3(null);
        setLastNode(null);
        setVisibleNodes([]);
      }
    }, "Reset filters") : null, mobileList2 ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: _Button.ButtonTypes.secondary,
      className: "custom-apply-btn",
      onClick: function onClick() {
        [mobileList2, mobileList3].forEach(function (listItem) {
          topicClicked(listItem.item);
        });
        setShowHeader(false);
      }
    }, "View ".concat(getCount(), " printables"), "\xA0", /*#__PURE__*/_react["default"].createElement(_rightArrow["default"], null)) : null));
  };
  var shouldShowBorder = function shouldShowBorder(item) {
    var _lastNode$item, _mobileList3$item2, _mobileList2$item2;
    if (lastNode && (lastNode === null || lastNode === void 0 ? void 0 : (_lastNode$item = lastNode.item) === null || _lastNode$item === void 0 ? void 0 : _lastNode$item.id) === item.id) {
      return 'selected';
    } else if (!lastNode && mobileList3 && (mobileList3 === null || mobileList3 === void 0 ? void 0 : (_mobileList3$item2 = mobileList3.item) === null || _mobileList3$item2 === void 0 ? void 0 : _mobileList3$item2.id) === item.id) {
      return 'selected';
    } else if (!lastNode && !mobileList3 && mobileList2 && (mobileList2 === null || mobileList2 === void 0 ? void 0 : (_mobileList2$item2 = mobileList2.item) === null || _mobileList2$item2 === void 0 ? void 0 : _mobileList2$item2.id) === item.id) {
      return 'selected';
    } else {
      return '';
    }
  };
  var renderMobileTopics = function renderMobileTopics(data, itemType, level) {
    var _data$children2;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mobile-list level".concat(level),
      "data-sentry-component": "renderMobileTopics",
      "data-sentry-source-file": "topicSelector.tsx"
    }, data === null || data === void 0 ? void 0 : (_data$children2 = data.children) === null || _data$children2 === void 0 ? void 0 : _data$children2.map(function (item) {
      var _item$children3;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.id,
        className: "worksheet-topic-container worksheet-topic-container__mobile ".concat(shouldShowBorder(item))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          if (level === 0) {
            setMobileList2({
              data: data,
              item: item
            });
            setMobileList3(null);
            setLastNode(null);
          } else if (level === 1) {
            setMobileList3({
              data: data,
              item: item
            });
            setLastNode(null);
          } else if (level === 2) {
            setLastNode({
              data: data,
              item: item
            });
          }
        },
        className: "worksheet-topic-name ".concat(visibleNodes[visibleNodes.length - 1] === item.id ? 'selected' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "worksheet-label"
      }, item.title), (item === null || item === void 0 ? void 0 : (_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_treeViewArrow["default"], null) : null));
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "topic-selector",
    "data-sentry-component": "WorksheetTopicSelector",
    "data-sentry-source-file": "topicSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "heading"
  }, isMobile ? "".concat(subjectCode === "ela" ? "Reading Topics" : "Math Topics") : worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? "TOPICS" : "Printable Topic"), isMobile ? renderMobileView() : renderDesktopTopics());
};
var _default = WorksheetTopicSelector;
exports["default"] = _default;